<template>
	<div>
		<b-dropdown v-bind:text="column_data[term-1][1]" style="margin:10px">
			<b-dropdown-item v-for="(col, index) in column_data" v-on:click="select(index+1)" :key="index">{{col[1]}}</b-dropdown-item>
		</b-dropdown>
		<layout-1 :table_name="'Reports'" :id=pageid :searchbar=false :navbar=false :term=term :termchange=true style="width:100%; height:calc(100vh - 125px);"></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data(){
		return{
			column_data:[],
			column_names:[],
        	term:Number,
			pageid:PAGES.CUSTOM_REPORTS_PAGE,
		}
	},
	async created(){
		this.select(1);
		this.search();
	},
	methods:{
		select(index){
			this.term = index;
		},
		search(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid,
						data:[
							'search'
						]
					}
				}
			).then((res) => {
				this.column_names = res.data.data.column_names;
				this.column_data = res.data.data.column_data;
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Reports.vue